import React from 'react';
import { Box } from '@mui/material';

const ImportTimelineLoadingAnimation = () => (
  <Box
    sx={{
      position: 'relative',
      width: 224,
      height: 112,
      mx: 'auto',
      '@keyframes sourcePulse': {
        '0%': { transform: 'translateY(0) scale(0.98)', opacity: 0.72 },
        '48%': { transform: 'translateY(-2px) scale(1)', opacity: 1 },
        '100%': { transform: 'translateY(0) scale(0.98)', opacity: 0.72 },
      },
      '@keyframes bucketReveal': {
        '0%': { opacity: 0.25, transform: 'translateX(-8px) scale(0.96)' },
        '46%': { opacity: 1, transform: 'translateX(0) scale(1)' },
        '100%': { opacity: 0.55, transform: 'translateX(0) scale(1)' },
      },
      '@keyframes flowLine': {
        '0%': { opacity: 0.18, transform: 'scaleX(0.38)' },
        '48%': { opacity: 0.68, transform: 'scaleX(1)' },
        '100%': { opacity: 0.18, transform: 'scaleX(0.38)' },
      },
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        left: 14,
        top: 18,
        width: 74,
        height: 76,
        borderRadius: '18px',
        border: '1px solid rgba(126, 93, 186, 0.26)',
        bgcolor: 'rgba(247, 244, 255, 0.98)',
        boxShadow: '0 12px 28px rgba(75, 55, 126, 0.12)',
        animation: 'sourcePulse 1700ms ease-in-out infinite',
      }}
    >
      <Box sx={{ position: 'absolute', left: 16, top: 14, width: 22, height: 4, borderRadius: 999, bgcolor: 'rgba(126, 93, 186, 0.42)' }} />
      <Box sx={{ position: 'absolute', left: 16, top: 28, right: 14, height: 4, borderRadius: 999, bgcolor: 'rgba(126, 93, 186, 0.24)' }} />
      <Box sx={{ position: 'absolute', left: 16, top: 42, right: 24, height: 4, borderRadius: 999, bgcolor: 'rgba(126, 93, 186, 0.20)' }} />
      <Box sx={{ position: 'absolute', left: 16, top: 56, width: 30, height: 4, borderRadius: 999, bgcolor: 'rgba(126, 93, 186, 0.18)' }} />
    </Box>

    <Box
      sx={{
        position: 'absolute',
        left: 92,
        right: 84,
        top: 55,
        height: 4,
        borderRadius: 999,
        transformOrigin: 'left center',
        bgcolor: 'rgba(91, 178, 125, 0.30)',
        animation: 'flowLine 1500ms ease-in-out infinite',
      }}
    />

    {[
      { label: 'Timeline', top: 12, delay: '0ms', color: '#4F927E' },
      { label: 'Knowledge', top: 43, delay: '170ms', color: '#7E5DBA' },
      { label: 'Documents', top: 74, delay: '340ms', color: '#A35C6B' },
    ].map((bucket) => (
      <Box
        key={bucket.label}
        sx={{
          position: 'absolute',
          right: 10,
          top: bucket.top,
          width: 96,
          height: 22,
          borderRadius: 999,
          border: `1px solid ${bucket.color}33`,
          bgcolor: `${bucket.color}12`,
          boxShadow: '0 8px 18px rgba(48, 74, 65, 0.08)',
          animation: 'bucketReveal 1700ms ease-out infinite',
          animationDelay: bucket.delay,
        }}
      >
        <Box sx={{ position: 'absolute', left: 10, top: 7, width: 8, height: 8, borderRadius: '50%', bgcolor: `${bucket.color}99` }} />
        <Box sx={{ position: 'absolute', left: 25, right: 11, top: 8, height: 6, borderRadius: 999, bgcolor: `${bucket.color}33` }} />
      </Box>
    ))}
  </Box>
);

export default ImportTimelineLoadingAnimation;
